module.exports = __webpack_public_path__ + "img/nav-right-with-contact-black-nissan.a45f0a07.png";